function CheckDetails (checkDetailsId, checkId, status, type, productId, productName, createdDate, qty, cadetQty, unitPrice, r_Points, taxId) {

  this.checkDetailsId = checkDetailsId;
  this.checkId = checkId;
  this.status = status;
  this.type = type;
  this.productId = productId;
  this.productName = productName;
  this.createdDate = createdDate;
  this.qty = qty;
  this.cadetQty = cadetQty;
  this.unitPrice = unitPrice;
  this.r_Points = r_Points;
  this.taxId = taxId;
  this.discountApplied = 0;
  this.voidNotes = null;
  this.discountNotes = null;

}

CheckDetails.prototype.createCheckDetailsOnApi = function(api) {
  return new Promise (function (resolve, reject) {
    let postCheckDetailsString = api.base_url + 'checkDetails?key=' + api.api +
      '&checkId=' + this.checkId +
      '&status=' + this.status + //1 - new
      '&type=' + this.type + //4 - Reservation
      '&productId=' + this.productId +
      '&productName=' + this.productName +
      '&createdDate=' + this.createdDate +
      '&qty=' + this.qty +
      '&cadetQty=' + this.cadetQty +
      '&unitPrice=' + this.unitPrice +
      '&discountApplied=' + this.discountApplied +
      '&taxId=' + this.taxId + //1 - VAT
      '&s_SaleBy=' + 'website' +
      '&r_Points=' + this.r_Points;

    fetch(postCheckDetailsString, {method: 'POST'})
      .then( response => {
        if( !response.ok ){
          throw Error(response.statusText);
        }
        return response;
      })
      .then( response =>
        response.json()
      )
      .then( newCheckId => {
        resolve(newCheckId);
      })
      .catch( err => {
        reject(err);
      })
  }.bind(this))
}

export default CheckDetails;
